import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import {T} from 'Actions/translate';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: theme.spacing.unit / 4,
    },
    noLabel: {
        marginTop: theme.spacing.unit,
    },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, that) {
    return {
        fontWeight:
            that.state.name === name.value
                ? that.props.theme.typography.fontWeightMedium
                : that.props.theme.typography.fontWeightRegular,
    };
}

class SingleSelect extends React.Component {
    state = {
        name: this.props.defaultValue || '', // 设置默认值
    };

    handleChange = (event) => {
        this.props.onChange(this.props.title, event.target.value);
        this.setState({name: event.target.value});
    };

    showLabelHandle = (value) => {
        const {selectOptions} = this.props;

        let selectedOption =
            selectOptions &&
            selectOptions.length > 0 &&
            selectOptions.find((option) => option.value === value);
        let labelValue = selectedOption ? selectedOption.label : '全部';

        return labelValue;
    };

    render() {
        const {classes, selectOptions, optionObj} = this.props;
        console.log(
            'optionObj======================',
            optionObj,
            selectOptions,
        );

        return (
            <div className={'single-container ' + classes.root}>
                <FormControl
                    className={classes.formControl + ' form-control-style'}>
                    <InputLabel
                        htmlFor="select-single-chip"
                        className="single-input-label">
                        {this.props.singleSelectPlaceholder}
                    </InputLabel>
                    <Select
                        disableUnderline={true}
                        value={this.state.name ? this.state.name : 0}
                        onChange={this.handleChange}
                        input={
                            <Input
                                name={this.props.singleSelectPlaceholder}
                                id="select-single-chip"
                            />
                        }
                        renderValue={(selected) => (
                            <div className={classes.chips}>
                                <Chip
                                    key={this.state.name ? this.state.name : 0}
                                    label={this.showLabelHandle(
                                        this.state.name,
                                    )}
                                    className={
                                        classes.chip + ' chip-select-style'
                                    }
                                />
                            </div>
                        )}
                        MenuProps={MenuProps}>
                        {selectOptions
                            ? selectOptions.map((name) => (
                                  <MenuItem
                                      key={name.value}
                                      value={name.value}
                                      className="menu-item-li"
                                      style={getStyles(name, this)}>
                                      {name.label}
                                  </MenuItem>
                              ))
                            : null}
                    </Select>
                </FormControl>
            </div>
        );
    }
}

SingleSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    defaultValue: PropTypes.string, // 添加默认值的PropTypes
    selectOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    singleSelectPlaceholder: PropTypes.string.isRequired,
};

SingleSelect.defaultProps = {
    defaultValue: '', // 默认值为空字符串
};

export default withStyles(styles, {withTheme: true})(SingleSelect);
